import React from "react";

export const AGE_CATEGORIES = [
  { id: "adultos", label: "Adultos", range: "+18", cls: "bg-[#003284]/10 text-[#003284]", group: "adultos" },
  { id: "baby", label: "Baby", range: "0-3 años", cls: "bg-pink-100 text-pink-700", group: "familiares" },
  { id: "mini", label: "Mini", range: "3-6 años", cls: "bg-amber-100 text-amber-700", group: "familiares" },
  { id: "junior", label: "Junior", range: "6-12 años", cls: "bg-emerald-100 text-emerald-700", group: "familiares" },
  { id: "teen", label: "Teen", range: "13-19 años", cls: "bg-violet-100 text-violet-700", group: "familiares" },
];

export const ADULT_CATEGORIES = AGE_CATEGORIES.filter((c) => c.group === "adultos");
export const FAMILY_CATEGORIES = AGE_CATEGORIES.filter((c) => c.group === "familiares");
export const FAMILY_IDS = FAMILY_CATEGORIES.map((c) => c.id);

// Categoría paraguas "Familiares" que engloba a Baby/Mini/Junior/Teen
export const FAMILY_FILTER = { id: "familiares", label: "Familiares", range: "en familia", cls: "bg-[#FF7F27]/10 text-[#FF7F27]" };

export function matchesAgeFilter(cats, edad) {
  if (!edad) return true;
  if (edad === "familiares") return (cats || []).some((c) => FAMILY_IDS.includes(c));
  return (cats || []).includes(edad);
}

export function AgeBadges({ ids, showRange = false, compact = false }) {
  const cats = AGE_CATEGORIES.filter((c) => (ids || []).includes(c.id));
  if (!cats.length) return null;
  if (compact) {
    return (
      <div className="flex flex-wrap gap-0.5" data-testid="age-badges">
        {cats.map((c) => (
          <span key={c.id} className={`rounded px-1 text-[8px] font-bold leading-tight ${c.cls}`}>{c.label}</span>
        ))}
      </div>
    );
  }
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="age-badges">
      {cats.map((c) => (
        <span key={c.id} className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-bold ${c.cls}`}>
          {c.label}{showRange && <span className="opacity-60 font-semibold">· {c.range}</span>}
        </span>
      ))}
    </div>
  );
}
